'use client';
import { jsx } from 'react/jsx-runtime';
import { useContext, useState, useMemo, createContext, useEffect } from 'react';
import { useId } from '../../hooks/use-id.js';

let a = createContext(void 0);
const ProgressBarContextProvider = ({ children: e })=>{
    let [o, t] = useState(void 0), i = useMemo(()=>({
            id: o,
            setId: t
        }), [
        o
    ]);
    return jsx(a.Provider, {
        value: i,
        children: e
    });
};
const useProgressBarContext = ()=>useContext(a);
const useProgressBarId = (r)=>{
    let e = useProgressBarContext(), o = useId(r);
    return useEffect(()=>{
        null == e || e.setId(o);
    }, [
        e,
        o
    ]), null == e ? void 0 : e.id;
};

export { ProgressBarContextProvider, useProgressBarContext, useProgressBarId };
